module.exports = __webpack_public_path__ + "img/trainee-cover.c32ab290.jpg";